<template>
  <hcm-card
    :resource="resource"
    :externalResource="false"
    :hasSource="false"
    :hasShare="false"
  >
    <v-expansion-panels flat accordion multiple>
      <v-expansion-panel
        v-for="i in subItems"
        :key="i.uuid"
        @click="trackExpand($event, i)"
      >
        <v-expansion-panel-header class="qa-question">{{
          i.title
        }}</v-expansion-panel-header>
        <v-expansion-panel-content class="qa-answer" eager>
          <span v-html="formatDescription(i.description)"></span>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </hcm-card>
</template>

<script>
import HCMCard from "./HCMCard.vue";
import marked from "marked";

export default {
  components: { "hcm-card": HCMCard },
  props: {
    resource: {
      type: Object,
      required: true
    },
    subItems: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDescription(desc) {
      return marked(desc);
    },
    trackExpand(event, i) {
      if (
        !event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        this.$ga.event({
          eventCategory: i.title,
          eventAction: "View"
        });
      }
    }
  }
};
</script>

<style scoped>
.v-expansion-panel-header--active {
  font-weight: 700;
}

.qa-question {
  font-size: 18px;
}

.qa-answer {
  padding-left: 20px;
}

::v-deep li {
  margin-top: 14px;
}

::v-deep img {
  max-width: 100%;
}

.content-detail {
  margin-top: 20px;
}
</style>
